import { createAction } from '@reduxjs/toolkit';
import { SwitchViewActionTypes, SWITCH_VIEW_TYPE } from './models';

export const svSelectView = createAction(
  SwitchViewActionTypes.SELECT_VIEW,
  (payload: SWITCH_VIEW_TYPE) => ({payload})
);
